export const fixInsight = (s: string | undefined | null) =>
  s?.replace('<br data-cke-filler="true">', '');

export const fixPartData = (htmlString: string) =>
  htmlString.replaceAll('<p></p>', '');
